/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import checkout from "views/platforms/new-platform/schemas/form";

const {
  formField: {
    platformName,
    platformExchange,
    vlcourtEmail,
    vlcourtPassword,
    queueIdentifier,
    routingKey,
    rmqsSelected,
    settleOnlyBets,
    validateBets,
    receiveSeperateStatistics,
    riskManagement,
    demo,
    hardProviderDown,
    nuRemove,
    compressMessage,
    traderView,
    promos,
    outrights,
  },
} = checkout;

const initialValues = {
  [platformName.name]: "",
  [platformExchange.name]: "",
  [vlcourtEmail.name]: "",
  [vlcourtPassword.name]: "",
  [queueIdentifier.name]: "",
  [routingKey.name]: "",
  [rmqsSelected.name]: [],
  [settleOnlyBets.name]: false,
  [validateBets.name]: false,
  [receiveSeperateStatistics.name]: false,
  [riskManagement.name]: false,
  [demo.name]: false,
  [hardProviderDown.name]: false,
  [nuRemove.name]: false,
  [compressMessage.name]: false,
  [traderView.name]: false,
  [promos.name]: false,
  [outrights.name]: 3,
};

export default initialValues;
